// Angular
import { Injectable } from '@angular/core';
// RxJS
import { BehaviorSubject, Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
// Object-Path
import * as objectPath from 'object-path';
// Service
import { MenuConfigService } from './menu-config.service';
import { UserService } from '../../../auth/_services/user.service';
import {
	User,
	currentUser
} from '../../../auth';
import { AppState } from '../../../reducers';

import { environment } from "../../../../../environments/environment";
import { SettingsService } from '../../../../views/pages/configuration/settings/settings.service';
import { PageSettingsData } from '../../../configuration/_models/config-settings.model';

@Injectable({
	providedIn: 'root'
})
export class MenuHorizontalService {
	// Public properties
	menuList$: BehaviorSubject<any> = new BehaviorSubject({});
	user: User;
	user$: Observable<User>;


	/**
	 * Service constructor
	 *
	 * @param menuConfigService: MenuConfigServcie
	 */
	constructor(
		private readonly settingsService: SettingsService,
		private readonly menuConfigService: MenuConfigService,
		private readonly userService: UserService,
		private readonly store: Store<AppState>
	) {
		this.user$ = this.store.pipe(select(currentUser));
		this.user$.subscribe(user => {
			this.user = user;
			this.loadMenu()
		})
	}

	/**
	 * Load menu list
	 */
	loadMenu() {
		this.user = this.userService.getLoggedInUser() || this.user;
		this.menuList$.next([]);
		// get menu list
		let menuItems = objectPath.get(this.menuConfigService.getMenus(), 'header.items') as Array<any>;

		//getting activated modules
		this.settingsService.getPageSettings("tenantModuleAccess").subscribe((data: PageSettingsData) => {
			if (data.settings) {
				// filter activated modules
				menuItems = menuItems.filter(it => data.settings.find(s => s.fieldKey == "tenantModuleAccess").value.includes(it.index))

				// filter user modules
				if (!this.user?.admin && this.user?.moduleAccess?.length)
					menuItems = menuItems.filter(item => this.user?.moduleAccess.find(i => i.m == item.index))

				// set list
				this.menuList$.next(menuItems);
			}
		})
	}
}
